import React from 'react'

import { learningObjectivesIntro, activitiesListIntro, standardActivities, initialPost, standardActivitiesClosing, closing, estimated, finalProjectsAndMoreResponsibility } from './AL00000Sprint00'
import { oreillyPlaylistICS, internalLink, IntroducingPythonSampleCode, tiobeIndex } from '../DataAndAPIs/Links'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'

import { matchmakerWebLink } from '../Activities/Matchmaker'
import { numberingSystemsLink } from '../Activities/PythonNumberingSystems'
import { finalProjectProposalLink } from '../Activities/FinalProjectProposal'
import { pythonAddCommitPushLink } from '../Activities/PythonAddCommitPush'
import { programmingTogether } from '../DataAndAPIs/Links'

export const al20000Sprint05 = () => {
	let sprint = 5

	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>
		<p><em>Wow!</em> Here we are in sprint 5. Very well done with {matchmakerWebLink()}.This sprint we switch gears 
		and focusing on Python the #1 most popular computing language in the world according to the {tiobeIndex()}.</p>

		{finalProjectsAndMoreResponsibility()}
		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Explore Networks and The Internet</li>
			<li>Learn to program with Python</li>
			<li>Master Functions</li>
			<li>Utilize Python to automate repetitive activities</li>
			<li>Create your Final Project Proposal</li>
		</ul>

		{list20000Sprint05(sprint)}
		{closing(sprint)}
	</div> )
}

export const list20000Sprint05 = (sprint) => {
	const pythonW3CPart1 = () => { return internalLink('Python Programming - Part 1', '/activity/python-w3c') }
	const pythonW3CPart2 = () => { return internalLink('Python Programming - Part 2', '/activity/python-w3c') }
	const daleChapter2Lecture = () => { return internalLink('lecture', '/activity-dale/2') }
	const daleNetworks = () => { return internalLink('lecture', '/activity-dale/15' )}
	return ( <div>
		{activitiesListIntro(sprint)}
		<p></p>
		<ol>
			{standardActivities(sprint, pythonAddCommitPushLink(), oreillyPlaylistICS())}
			<li>Complete “Hello World with Python” from our {programmingTogether()} tutorials</li>
			<li>Review {pythonW3CPart1()} from W3C</li>
			<li>Start working on {finalProjectProposalLink()}</li>
			<li>Review “Computer Science Illuminated” The Information Layer focusing on Numbering Systems including the {daleChapter2Lecture()}</li>
			<li>Complete {numberingSystemsLink()}{estimated('2 hours')}</li>

			{initialPost(sprint)}
			<li>Within “Computer Science Illuminated” Networks and review our associated {daleNetworks()}</li>
			<li>Review {pythonW3CPart2()} from W3C</li>
			<li>Within {oreillyPlaylistICS()} read “Introducing Python” Preface through Chapter 1 while reviewing the {IntroducingPythonSampleCode()}</li>
			<li>Complete {finalProjectProposalLink()}{estimated('2 hours')}</li>
			{standardActivitiesClosing(sprint, pythonAddCommitPushLink(), '4 hours')}
		</ol>
	</div> )
}


// Todo: Consider where Networking should fit in relative to WWW as it feels more than a little awkward here.
// Todo: Review programming assign and create lite tutorials including one for adding aliases on Windows and Mac.

// Certified for SP25 on March 19, 2025... above items were not changed, but likely should be changed. 





